import React from 'react';
import defaultLocales from 'globals/locales/default';
import FsSimpleInput from 'ui-elements/form-elements/FsDefaultInput/FsDefaultInput';
import FsFormFullWidthContainer from 'ui-elements/form-elements/FsFormFullWidthContainer';
import FsPhoneNumberInput from 'ui-elements/form-elements/FsPhoneNumberInput';

const getLabel = (fieldName: string): string => {
  switch (fieldName) {
    case 'firstName':
      return defaultLocales.firstName;
    case 'lastName':
      return defaultLocales.lastName;
    case 'email':
      return defaultLocales.email;
    case 'phoneNumber':
      return defaultLocales.phoneNumber;
    default:
      return '';
  }
};

export interface UserDetailsSingleRowDataProps {
  name: string;
  value: string;
}

export interface UserDetailsSingleRowProps
  extends UserDetailsSingleRowDataProps {
  onChange?: ({ value, name }: UserDetailsSingleRowDataProps) => void;
}

const UserDetailsSingleRow: React.FC<UserDetailsSingleRowProps> = ({
  name = '',
  value = '',
  onChange,
}) => {
  const handleChange = async (newValue: string) => {
    if (onChange) onChange({ name, value: newValue });
  };

  return (
    <FsFormFullWidthContainer>
      {name === 'phoneNumber' ? (
        <FsPhoneNumberInput
          value={value}
          onChange={(phoneNumber) => handleChange(phoneNumber)}
          placeholder="+44"
        />
      ) : (
        <FsSimpleInput
          required={name === 'firstName' || name === 'email'}
          fsVariant="outlined"
          fullWidth
          name={name}
          label={getLabel(name)}
          value={value}
          disabled={name === 'email'}
          onChange={(e) => handleChange(e.target.value)}
        />
      )}
    </FsFormFullWidthContainer>
  );
};

export default UserDetailsSingleRow;
